import { components } from '@/utils'

import generatorRow from '@/components/generator/row'
import { baseClass } from '@/components/rules/utils'

function renderItem(h, item, index) {
  return h(
    components.textarea,
    {
      props: {
        value: item.text,
        label: this.getTranslate(`${baseClass}.labels.text`),
        defaultValue: '',
        details: false,
        grow: true,
        dense: true,
        clearable: true
      },
      on: {
        input: event => {
          this.$set(this.proxy, index, {
            ...item,
            text: event
          })
        }
      }
    }
  )
}

export default function(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy,
        defaultValue: { text: undefined }
      },
      scopedSlots: {
        row: ({ item, index }) => {
          return renderItem.call(this, h, item, index)
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
